import React, { useEffect, useState } from 'react'
import {
  ControllerAsignacionAntecendentePaciente,
  ControllerListarAntecedentepaciente,
  ControllerTipoAntecedente
} from '../../../Service/Service.antecedente'
import Familiar from './Familiar'
import Fisico from './Fisicos'
import Organos from './Organos'
import Personal from './Personal'

export default function InfoHistorial() {
  const [tipoAntecedente, setTipoAntecedente] = useState([])
  const [descripcion, setDescripcion] = useState([])
  const [tabActivo, setTabActivo] = useState(null)

  useEffect(() => {
    (async () => {
      const lis = await ControllerTipoAntecedente()
      if (lis && lis.success) {
        // CONSULTA-EVOLUCION-REDISENO: "Revisión de órganos" (cat 3) y
        // "Revisión física" (cat 4) NO son antecedentes del paciente: son
        // hallazgos de la visita y ahora se registran en la hoja de consulta
        // (guardan por cita, ya lo hacían). Aquí se quedan solo Personal (1) y
        // Familiares (2). No se toca la base ni el endpoint.
        const soloAntecedentes = (lis.data || []).filter(
          (t) => ![3, 4].includes(t.id_categoria_antecedente)
        )
        setTipoAntecedente(soloAntecedentes)

        // Carga la primera categoría por defecto
        const primerTipo = soloAntecedentes[0].id_categoria_antecedente
        setTabActivo(primerTipo)
        await cargarAntecedentes(primerTipo)
      }
    })()
  }, [])

  const cargarAntecedentes = async (tipo) => {
    const urlParams = new URLSearchParams(window.location.search)
    let id_paciente = urlParams.get('idpaciente')
    let id_cita = urlParams.get('idcita')
    if (!id_paciente) return console.log('No se encontró el id del paciente')

    let data = []

    if (tipo === 4) {
      // ✅ Físico: SOLO antecedentes físicos
      const pasFisico = await ControllerListarAntecedentepaciente(
        id_paciente,
        4,
        id_cita
      )
      if (pasFisico && pasFisico.success) {
        data = pasFisico.data.map((fisicoItem) => {
          if (
            !fisicoItem.antecedentes_paciente ||
            fisicoItem.antecedentes_paciente.length === 0
          ) {
            fisicoItem.antecedentes_paciente = [
              {
                id_antecedente_paciente: null,
                idpaciente: id_paciente,
                id_antecedente: fisicoItem.id_antecedente,
                tiene: false,
                cp: false,
                sp: false,
                observacion: '',
                idclinica: null,
                fecha_insert: null,
                fecha_update: null,
                id_cita: id_cita,
                id_categoria_antecedente: 4
              }
            ]
          } else {
            fisicoItem.antecedentes_paciente[0].id_categoria_antecedente = 4
          }
          return fisicoItem
        })
      }
    } else {
      const pas = await ControllerListarAntecedentepaciente(
        id_paciente,
        tipo,
        id_cita
      )
      if (pas && pas.success) {
        data = pas.data
      }
    }

    setDescripcion(data)
  }

  const handleTabClick = async (tipo) => {
    setTabActivo(tipo)
    await cargarAntecedentes(tipo)
  }

  const asignarAntecedente = async (
    id_antecedente,
    observacion,
    idpaciente,
    tiene,
    cp,
    sp,
    id_categoria_antecedente,
    id_cita
  ) => {
    const asig = await ControllerAsignacionAntecendentePaciente(
      id_antecedente,
      observacion,
      idpaciente,
      tiene,
      cp,
      sp,
      id_cita
    )
    if (asig && asig.success) {
      await cargarAntecedentes(id_categoria_antecedente)
    }
  }

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="email-leftbar card" style={{ width: '163px' }}>
            <div
              className="nav flex-column nav-pills mail-list mt-4"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              {tipoAntecedente.map((tipo, index) => (
                <a
                  key={index}
                  className={`nav-link mb-2 ${
                    tabActivo === tipo.id_categoria_antecedente ? 'active' : ''
                  }`}
                  id={`t-ananm-${String(
                    tipo.categoria_antecendente
                  )
                    .toLowerCase()
                    .replace(' ', '-')}-tab`}
                  data-bs-toggle="pill"
                  href={`#t-ananm-${String(
                    tipo.categoria_antecendente
                  )
                    .toLowerCase()
                    .replace(' ', '-')}`}
                  role="tab"
                  aria-controls={`t-ananm-${String(
                    tipo.categoria_antecendente
                  )
                    .toLowerCase()
                    .replace(' ', '-')}`}
                  aria-selected={
                    tabActivo === tipo.id_categoria_antecedente
                      ? 'true'
                      : 'false'
                  }
                  onClick={(e) => {
                    e.preventDefault()
                    handleTabClick(tipo.id_categoria_antecedente)
                  }}
                >
                  {tipo.categoria_antecendente}
                </a>
              ))}
            </div>
          </div>

          <div className="email-rightbar mb-3" style={{ marginLeft: '177px' }}>
            <div className="card">
              <div
                className="tab-content text-muted mt-4 mt-md-0 p-3"
                id="v-pills-tabContent"
              >
                {tabActivo === 1 && (
                  <Personal
                    descripcion={descripcion}
                    setDescripcion={setDescripcion}
                    asignarAntecedente={asignarAntecedente}
                  />
                )}
                {tabActivo === 2 && (
                  <Familiar
                    descripcion={descripcion}
                    setDescripcion={setDescripcion}
                    asignarAntecedente={asignarAntecedente}
                  />
                )}
                {tabActivo === 3 && (
                  <Organos
                    descripcion={descripcion}
                    setDescripcion={setDescripcion}
                    asignarAntecedente={asignarAntecedente}
                  />
                )}
                {tabActivo === 4 && (
                  <Fisico
                    descripcion={descripcion}
                    setDescripcion={setDescripcion}
                    asignarAntecedente={asignarAntecedente}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
